import React from 'react';

import styles from './Footer.module.scss';


class Footer extends React.Component {
  constructor(props) {
    super(props);

    this.dateYear = new Date().getFullYear();
  }

  render() {
    return (
      <footer>
        <div className={styles.Description}>&copy; {this.dateYear} - Wszelkie prawa zastrzeżone.</div>
      </footer>
    );
  }
}

export default Footer;
